/*  DATA  */
const CM={'Obsidian':'#1a1a18','EBB Blue':'#6b9ab8','Chalk':'#f0ede8','Slate':'#8a8680','Forest':'#2e3530','Sky':'#a8c4d6','Black':'#1a1a18','White':'#f5f5f5','Navy':'#1a2340','Grey':'#8a8680','Gray':'#8a8680','London Fog':'#b8b0a8','Cream':'#f0ede8','Tan':'#c4956a','Brown':'#6b4c3b','Olive':'#6b6b3a','Burgundy':'#6b1a2a','Camel':'#c4956a'};

// Each product has unique premium imagery params
const PLACEHOLDER_P=[
  {id:1,name:'Foundation Performance Tee',cat:'Shirts',pur:'Performance',price:128,
   colors:['Obsidian','EBB Blue','Chalk'],sizes:['S','M','L','XL','XXL'],soldOut:['S'],badge:'new',
   det:'85% Recycled Nylon, 15% Elastane. 4-way stretch. Moisture control. Anti-odor. UPF 50+.',
   img:{bg1:'#252220',bg2:'#1a1816',skin:'#c4956a',o1:'#1a1a18',o2:'#232320'}},
  {id:2,name:'Precision Training Short',cat:'Shorts',pur:'Performance',price:148,
   colors:['Obsidian','Forest','Slate'],sizes:['S','M','L','XL'],soldOut:['XL'],badge:null,
   det:'92% Recycled Polyester, 8% Elastane. Built-in liner. Flatlock seams. Zip pocket. UPF 40+.',
   img:{bg1:'#1e2820',bg2:'#162018',skin:'#c4956a',o1:'#2e3530',o2:'#1a1a18'}},
  {id:3,name:'Elite Quarter Zip',cat:'Quarter Zips',pur:'Everyday',price:228,
   colors:['Obsidian','EBB Blue','Chalk'],sizes:['S','M','L','XL','XXL'],soldOut:['S','M'],badge:'best',
   det:'62% Premium Cotton, 38% Recycled Polyester. Brushed exterior. YKK zip. Raglan sleeves.',
   img:{bg1:'#d8d4ce',bg2:'#c8c4be',skin:'#c4956a',o1:'#1a1a18',o2:'#2a2620'}},
  {id:4,name:'Recovery Lounge Pant',cat:'Pants',pur:'Recovery',price:188,
   colors:['Obsidian','Slate','EBB Blue'],sizes:['S','M','L','XL'],soldOut:[],badge:null,
   det:'78% Modal, 18% Nylon, 4% Elastane. Compression-lite. Deep pockets. Tapered leg.',
   img:{bg1:'#e8e4de',bg2:'#d8d4ce',skin:'#c4956a',o1:'#6b9ab8',o2:'#1a1a18'}},
  {id:5,name:'Tactical Performance Polo',cat:'Polos',pur:'Everyday',price:168,
   colors:['Obsidian','Forest','EBB Blue','Chalk'],sizes:['S','M','L','XL','XXL'],soldOut:['XXL'],badge:'new',
   det:'80% Pima Cotton, 20% Performance Nylon. Moisture-wicking. Flat-knit collar. 3-button placket.',
   img:{bg1:'#1c2028',bg2:'#141820',skin:'#c4956a',o1:'#f0ede8',o2:'#6b9ab8'}},
  {id:6,name:'Foundation Hoodie',cat:'Hoodies',pur:'Recovery',price:248,
   colors:['Obsidian','EBB Blue','Slate'],sizes:['S','M','L','XL','XXL'],soldOut:['S','XL'],badge:null,
   det:'100% 400gsm Ring-Spun Cotton. Heavy fleece interior. Split kangaroo pocket. Preshrunk.',
   img:{bg1:'#282420',bg2:'#1e1c18',skin:'#c4956a',o1:'#2a2620',o2:'#1a1a18'}}
];

const P = (window.SHOPIFY_PRODUCTS && window.SHOPIFY_PRODUCTS.length) ? window.SHOPIFY_PRODUCTS : PLACEHOLDER_P;

/*  STATE  */
let cur=null,selSz=null,selCI=0,cF=[],maxP=400,fil=[...P];

/*  PRODUCT IMAGE HELPER  */
function prodImg(p, w, h, angle) {
  if (p.imgUrl) return '<img src="'+p.imgUrl+'" alt="'+p.name+'" style="width:100%;height:100%;object-fit:cover;display:block;">';
  return figSVG(p, w, h, angle||0);
}

/*  PREMIUM SVG IMAGERY  */
// Consistent editorial figure  warm charcoal bg, cinematic lighting
function figSVG(p, w=300, h=400, variant=0) {
  const i = p.img;
  const id = 'f'+p.id+'_'+variant+'_'+Math.random().toString(36).slice(2,4);
  const cx = w/2 + (variant===1 ? w*0.04 : 0);
  const headY = h*0.22;
  const headRx = w*0.125, headRy = h*0.155;
  // Variant 1: slight lean/different pose
  const armOffset = variant===1 ? w*0.02 : 0;
  return `<svg viewBox="0 0 ${w} ${h}" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%;display:block">
  <defs>
    <linearGradient id="bg_${id}" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="${i.bg1}"/><stop offset="100%" stop-color="${i.bg2}"/>
    </linearGradient>
    <radialGradient id="sp_${id}" cx="38%" cy="22%" r="52%">
      <stop offset="0%" stop-color="rgba(255,255,255,0.09)"/><stop offset="100%" stop-color="rgba(0,0,0,0)"/>
    </radialGradient>
    <radialGradient id="vg_${id}" cx="50%" cy="50%" r="70%">
      <stop offset="30%" stop-color="rgba(0,0,0,0)"/><stop offset="100%" stop-color="rgba(0,0,0,0.32)"/>
    </radialGradient>
    <radialGradient id="gs_${id}" cx="50%" cy="96%" r="30%">
      <stop offset="0%" stop-color="rgba(0,0,0,0.28)"/><stop offset="100%" stop-color="rgba(0,0,0,0)"/>
    </radialGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="url(#bg_${id})"/>
  <rect width="${w}" height="${h}" fill="url(#sp_${id})"/>
  <!-- Ground shadow -->
  <ellipse cx="${cx}" cy="${h*0.962}" rx="${w*0.19}" ry="${h*0.019}" fill="rgba(0,0,0,0.28)"/>
  <!-- Legs -->
  <rect x="${cx-w*0.098}" y="${h*0.465}" width="${w*0.086}" height="${h*0.47}" rx="${w*0.043}" fill="${i.o2}" opacity="0.93"/>
  <rect x="${cx+w*0.012}" y="${h*0.465}" width="${w*0.086}" height="${h*0.47}" rx="${w*0.043}" fill="${i.o2}" opacity="0.87"/>
  <!-- Torso -->
  <rect x="${cx-w*0.155+armOffset}" y="${h*0.358}" width="${w*0.31}" height="${h*0.125}" rx="${w*0.02}" fill="${i.o1}" opacity="0.95"/>
  <rect x="${cx-w*0.155+armOffset}" y="${h*0.358}" width="${w*0.31}" height="${h*0.032}" rx="${w*0.016}" fill="rgba(107,154,184,0.28)"/>
  <rect x="${cx-w*0.155+armOffset}" y="${h*0.475}" width="${w*0.31}" height="${h*0.015}" rx="${w*0.007}" fill="rgba(255,255,255,0.07)"/>
  <!-- Logo on chest -->
  <text x="${cx+armOffset}" y="${h*0.432}" font-family="sans-serif" font-size="${w*0.038}" fill="rgba(255,255,255,0.25)" font-weight="600" text-anchor="middle" letter-spacing="2">EBB</text>
  <!-- Arms -->
  <rect x="${cx-w*0.238+armOffset}" y="${h*0.362}" width="${w*0.078}" height="${h*0.245}" rx="${w*0.039}" fill="${i.skin}" opacity="0.74"/>
  <rect x="${cx+w*0.16+armOffset}" y="${h*0.362}" width="${w*0.078}" height="${h*0.245}" rx="${w*0.039}" fill="${i.skin}" opacity="0.70"/>
  <!-- Neck -->
  <rect x="${cx-w*0.048}" y="${h*0.28}" width="${w*0.096}" height="${h*0.09}" rx="${w*0.048}" fill="${i.skin}" opacity="0.82"/>
  <!-- Head -->
  <ellipse cx="${cx}" cy="${headY}" rx="${headRx}" ry="${headRy}" fill="${i.skin}" opacity="0.9"/>
  <!-- Hair  editorial close crop -->
  <ellipse cx="${cx}" cy="${headY - headRy*0.55}" rx="${headRx*1.08}" ry="${headRy*0.55}" fill="rgba(16,12,8,0.92)"/>
  <path d="M${cx-headRx*0.7} ${headY-headRy*0.2} Q${cx-headRx*0.5} ${headY+headRy*0.3} ${cx-headRx*1.1} ${headY+headRy*0.6}" stroke="rgba(16,12,8,0.6)" stroke-width="${w*0.025}" fill="none" stroke-linecap="round"/>
  <!-- Rim light -->
  <rect x="${cx+w*0.14+armOffset}" y="${h*0.358}" width="${w*0.014}" height="${h*0.125}" fill="rgba(255,255,255,0.13)"/>
  <ellipse cx="${cx+headRx*0.85}" cy="${headY}" rx="${headRx*0.12}" ry="${headRy*0.5}" fill="rgba(255,255,255,0.08)"/>
  <rect width="${w}" height="${h}" fill="url(#vg_${id})"/>
  <rect width="${w}" height="${h}" fill="url(#gs_${id})"/>
</svg>`;
}

// Wide campaign hero
function heroSVG() {
  return '<img src="' + (window.__ebbAssets && window.__ebbAssets.heroBg || '') + '" style="width:100%;height:100%;object-fit:cover;object-position:center 25%;display:block;" alt="EBB Campaign" loading="eager"/>';
}

// Editorial 2-figure for duo shots
function duoSVG(dark=true) {
  const id = 'duo_'+Math.random().toString(36).slice(2,4);
  const bg = dark ? ['#1e1c18','#252220'] : ['#d8d4ce','#c8c4bc'];
  const skin = '#c4956a';
  const f1suit = dark ? '#1a1a18' : '#2a2620';
  const f2suit = dark ? '#6b9ab8' : '#1a1a18';
  return `<svg viewBox="0 0 700 640" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%;display:block">
  <defs>
    <linearGradient id="bg_${id}" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="${bg[0]}"/><stop offset="100%" stop-color="${bg[1]}"/>
    </linearGradient>
    <radialGradient id="sp_${id}" cx="50%" cy="25%" r="50%">
      <stop offset="0%" stop-color="rgba(255,255,255,0.07)"/><stop offset="100%" stop-color="rgba(0,0,0,0)"/>
    </radialGradient>
    <radialGradient id="vg_${id}" cx="50%" cy="50%" r="70%">
      <stop offset="40%" stop-color="rgba(0,0,0,0)"/><stop offset="100%" stop-color="rgba(0,0,0,0.3)"/>
    </radialGradient>
  </defs>
  <rect width="700" height="640" fill="url(#bg_${id})"/>
  <rect width="700" height="640" fill="url(#sp_${id})"/>
  <!-- Figure 1 (main, left) -->
  <ellipse cx="290" cy="620" rx="90" ry="14" fill="rgba(0,0,0,0.24)"/>
  <rect x="252" y="368" width="62" height="244" rx="31" fill="${f1suit}" opacity="0.93"/>
  <rect x="324" y="368" width="62" height="244" rx="31" fill="${f1suit}" opacity="0.87"/>
  <rect x="210" y="238" width="190" height="146" rx="22" fill="${f1suit}" opacity="0.95"/>
  <rect x="210" y="238" width="190" height="30" rx="15" fill="rgba(107,154,184,0.3)"/>
  <text x="305" y="324" font-family="sans-serif" font-size="18" fill="rgba(255,255,255,0.2)" font-weight="700" text-anchor="middle" letter-spacing="4">EBB</text>
  <rect x="148" y="245" width="58" height="170" rx="29" fill="${skin}" opacity="0.72"/>
  <rect x="404" y="245" width="58" height="170" rx="29" fill="${skin}" opacity="0.68"/>
  <rect x="272" y="175" width="52" height="76" rx="26" fill="${skin}" opacity="0.82"/>
  <ellipse cx="298" cy="148" rx="66" ry="85" fill="${skin}" opacity="0.90"/>
  <ellipse cx="298" cy="84" rx="72" ry="68" fill="rgba(16,12,8,0.94)"/>
  <rect x="400" y="238" width="10" height="146" fill="rgba(255,255,255,0.1)"/>
  <!-- Figure 2 (behind/right) -->
  <ellipse cx="530" cy="628" rx="70" ry="11" fill="rgba(0,0,0,0.16)"/>
  <rect x="498" y="390" width="50" height="232" rx="25" fill="${f2suit}" opacity="0.85"/>
  <rect x="558" y="390" width="50" height="232" rx="25" fill="${f2suit}" opacity="0.80"/>
  <rect x="464" y="268" width="166" height="136" rx="18" fill="${f2suit}" opacity="0.88"/>
  <rect x="422" y="274" width="46" height="140" rx="23" fill="${skin}" opacity="0.62"/>
  <rect x="632" y="274" width="46" height="140" rx="23" fill="${skin}" opacity="0.58"/>
  <rect x="506" y="208" width="44" height="68" rx="22" fill="${skin}" opacity="0.75"/>
  <ellipse cx="528" cy="182" rx="54" ry="72" fill="${skin}" opacity="0.82"/>
  <ellipse cx="528" cy="126" rx="60" ry="58" fill="rgba(16,12,8,0.9)"/>
  <text x="700" y="620" font-family="sans-serif" font-size="14" fill="rgba(255,255,255,0.06)" font-weight="400" text-anchor="end" letter-spacing="8">EBB ACTIVE</text>
  <rect width="700" height="640" fill="url(#vg_${id})"/>
</svg>`;
}

// Clean product flat / texture shot  for category and editorial variety
function flatSVG(color1, color2, accent='#6b9ab8') {
  const id = 'flat_'+Math.random().toString(36).slice(2,4);
  return `<svg viewBox="0 0 700 640" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%;display:block">
  <defs>
    <linearGradient id="bg_${id}" x1="0%" y1="20%" x2="100%" y2="80%">
      <stop offset="0%" stop-color="${color1}"/><stop offset="100%" stop-color="${color2}"/>
    </linearGradient>
    <radialGradient id="hl_${id}" cx="28%" cy="28%" r="52%">
      <stop offset="0%" stop-color="rgba(255,255,255,0.13)"/><stop offset="100%" stop-color="rgba(0,0,0,0)"/>
    </radialGradient>
    <radialGradient id="vg_${id}" cx="50%" cy="50%" r="70%">
      <stop offset="40%" stop-color="rgba(0,0,0,0)"/><stop offset="100%" stop-color="rgba(0,0,0,0.28)"/>
    </radialGradient>
  </defs>
  <rect width="700" height="640" fill="url(#bg_${id})"/>
  <!-- Main garment shape -->
  <path d="M80 180 Q350 120 620 195 L650 580 L50 580Z" fill="${color2}" opacity="0.88" transform="rotate(-2 350 320)"/>
  <!-- Secondary layer -->
  <path d="M160 240 Q350 190 540 255 L560 580 L140 580Z" fill="rgba(255,255,255,0.07)"/>
  <!-- Seam line detail -->
  <line x1="160" y1="320" x2="540" y2="320" stroke="rgba(255,255,255,0.12)" stroke-width="1.5"/>
  <line x1="350" y1="200" x2="350" y2="570" stroke="rgba(255,255,255,0.08)" stroke-width="1"/>
  <!-- Accent element -->
  <rect x="315" y="295" width="70" height="52" rx="4" fill="${accent}" opacity="0.22"/>
  <!-- Logo mark -->
  <text x="350" y="342" font-family="sans-serif" font-size="32" fill="rgba(255,255,255,0.28)" font-weight="700" text-anchor="middle" letter-spacing="8">EBB</text>
  <text x="350" y="372" font-family="sans-serif" font-size="13" fill="rgba(255,255,255,0.14)" font-weight="300" text-anchor="middle" letter-spacing="7">ACTIVE · SS25</text>
  <rect width="700" height="640" fill="url(#hl_${id})"/>
  <rect width="700" height="640" fill="url(#vg_${id})"/>
</svg>`;
}

// Team portrait  editorial headshot style
function portraitSVG(skinTone, bgColor, outfitColor, hairShade='rgba(16,12,8,0.92)') {
  const id = 'por_'+Math.random().toString(36).slice(2,4);
  return `<svg viewBox="0 0 400 530" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%;display:block">
  <defs>
    <linearGradient id="bg_${id}" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="${bgColor}"/><stop offset="100%" stop-color="${bgColor}cc"/>
    </linearGradient>
    <radialGradient id="sp_${id}" cx="35%" cy="20%" r="55%">
      <stop offset="0%" stop-color="rgba(255,255,255,0.11)"/><stop offset="100%" stop-color="rgba(0,0,0,0)"/>
    </radialGradient>
    <radialGradient id="vg_${id}" cx="50%" cy="50%" r="70%">
      <stop offset="35%" stop-color="rgba(0,0,0,0)"/><stop offset="100%" stop-color="rgba(0,0,0,0.25)"/>
    </radialGradient>
  </defs>
  <rect width="400" height="530" fill="url(#bg_${id})"/>
  <rect width="400" height="530" fill="url(#sp_${id})"/>
  <!-- Shoulders/torso -->
  <rect x="100" y="320" width="200" height="210" rx="20" fill="${outfitColor}" opacity="0.92"/>
  <rect x="100" y="320" width="200" height="28" rx="14" fill="rgba(107,154,184,0.25)"/>
  <!-- Arms partial -->
  <rect x="36" y="328" width="62" height="170" rx="31" fill="${skinTone}" opacity="0.7"/>
  <rect x="302" y="328" width="62" height="170" rx="31" fill="${skinTone}" opacity="0.66"/>
  <!-- Neck -->
  <rect x="180" y="256" width="40" height="76" rx="20" fill="${skinTone}" opacity="0.84"/>
  <!-- Head  larger for portrait -->
  <ellipse cx="200" cy="206" rx="82" ry="102" fill="${skinTone}" opacity="0.92"/>
  <!-- Hair -->
  <ellipse cx="200" cy="132" rx="90" ry="82" fill="${hairShade}"/>
  <!-- Rim light -->
  <ellipse cx="276" cy="210" rx="12" ry="50" fill="rgba(255,255,255,0.09)"/>
  <text x="200" y="490" font-family="sans-serif" font-size="11" fill="rgba(255,255,255,0.12)" font-weight="400" text-anchor="middle" letter-spacing="6">EBB ACTIVE</text>
  <rect width="400" height="530" fill="url(#vg_${id})"/>
</svg>`;
}

/*  PRODUCT CARD  */
function card(p) {
  const bh = p.badge ? `<div class="pc-bdg ${p.badge}">${p.badge==='new'?'New Arrival':p.badge==='best'?'Best Seller':'Limited'}</div>` : '';
  const dots = p.colors.map(c=>`<div class="pip" style="background:${CM[c]||'#888'};${c==='Chalk'||c==='White'||c==='Cream'?'border:2px solid #d0ccc8':''}" title="${c}"></div>`).join('');
  const so = p.soldOut || [];
  const szPills = (p.sizes||[]).map(s=>`<span class="pc-sz${so.includes(s)?' so':''}" onclick="event.stopPropagation()">${s}</span>`).join('');
  const firstColor = p.colors && p.colors.length > 0 ? p.colors[0] : '';
  return `<div class="pc" onclick="openProd(${p.id})">
    <div class="pc-img">
      ${prodImg(p, 300, 400)}
      ${bh}
      <button class="pc-wish" onclick="event.stopPropagation();this.classList.toggle('liked');toast(this.classList.contains('liked')?'Saved ':'Removed')">
        <svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>
      </button>
      <div class="pc-sizes">${szPills}</div>
    </div>
    <div class="pc-info">
      <div class="pc-dots">${dots}</div>
      <div class="pc-name">${p.handle?`<a href="/products/${p.handle}" style="color:inherit;text-decoration:none" onclick="event.stopPropagation()">${p.name}</a>`:p.name}</div>
      ${firstColor ? `<div class="pc-col-name">${firstColor}</div>` : ''}
      <div class="pc-price">$${p.price}</div>
    </div>
  </div>`;
}

/*  PAGES  */
function showPage(n){
  document.querySelectorAll('.page').forEach(p=>p.classList.remove('active'));
  document.getElementById('page-'+n).classList.add('active');
  document.querySelectorAll('.nav-lnk').forEach(a=>a.classList.remove('on'));
  window.scrollTo({top:0,behavior:'smooth'});
  if(n==='shop') renderShop();
  if(n==='home') renderHome();
  if(n==='collections') renderColl();
  if(n==='about') renderAbout();
  // Set active nav link
  const map={'home':0,'shop':1,'collections':2,'about':3};
  const links = document.querySelectorAll('.nav-lnk');
  if(map[n]!==undefined) links[map[n]].classList.add('on');
}
function goHome(){showPage('home')}

/*  HOME  */
function renderHome() {
  if(!document.getElementById('page-home'))return;
  var _hb=document.getElementById('heroBg');
  // PageBot polish item 1: hero film v5 (the client's edit, 19.6 s, opening at 1.5x, weak/jumpy parts removed;
  // docs/VIDEO.md). Phones get a 1.19 MB portrait cut with per-shot crops, desktop a 3.6 MB 16:9 cut; the poster is in the HTML and paints first;
  // preload=metadata; reduced-motion users get the poster only.
  var _A=window.EBB_ASSETS||{}, _mob=window.matchMedia('(max-width: 768px)').matches;
  var _vsrc=_mob?(_A.heroVideoMobile||_A.heroVideo):_A.heroVideo, _vpos=_mob?(_A.heroPosterMobile||_A.heroPoster):_A.heroPoster;
  var _still=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Theme settings › Homepage hero = Static image: the <picture> is server-rendered in #heroBg; leave it alone.
  if(_A.heroMode==='image'&&_hb&&_hb.querySelector('.pb-hero-pic')){}
  else if(_hb&&_vsrc&&!_still){
    _hb.innerHTML='<video autoplay muted loop playsinline preload="metadata" poster="'+(_vpos||'')+'" aria-hidden="true" style="width:100%;height:100%;object-fit:cover;display:block"><source src="'+_vsrc+'" type="video/mp4"></video>';
    var _v=_hb.querySelector('video');if(_v){_v.muted=true;var _pp=_v.play();if(_pp&&_pp.catch)_pp.catch(function(){});}
  }else if(_hb&&_vpos){_hb.style.backgroundImage='url('+_vpos+')';_hb.style.backgroundSize='cover';_hb.style.backgroundPosition='center';}
  else if(!_hb){}else if(window.EBB_ASSETS?.heroImg){_hb.style.backgroundImage='url('+window.EBB_ASSETS.heroImg+')';_hb.style.backgroundSize='cover';_hb.style.backgroundPosition='center 30%';}else{_hb.innerHTML=heroSVG();}

  // Below-hero: New Arrivals photo left + philosophy statement right
  // PageBot polish item 5: the New Arrivals photo tile is replaced by the product rail above; the philosophy
  // becomes one slim band (styles in pb-polish.css, .below-hero.pb-band).
  var _bhEl = document.getElementById('belowHero');
  if (_bhEl) { _bhEl.classList.add('pb-band'); _bhEl.innerHTML = `
    <a class="bh-philo" href="/pages/about">
      <p class="bh-philo-eyebrow">The philosophy</p>
      <p class="bh-philo-line pb-band-lines">Before the sun. After the crowd. Where nobody&rsquo;s watching &mdash; that&rsquo;s where it&rsquo;s built.</p>
      <span class="bh-philo-link">Read our story</span>
    </a>`; }

  const hg = document.getElementById('homeGrid'); if(hg) hg.innerHTML = P.slice(0,4).map(card).join('');

  // Editorial 1: dark duo shot
  var _e1=document.getElementById('ed1');if(window.EBB_ASSETS?.ed1Img){_e1.style.backgroundImage='url('+window.EBB_ASSETS.ed1Img+')';_e1.style.backgroundSize='cover';_e1.style.backgroundPosition='center top';}else{_e1.innerHTML=duoSVG(true);}

  // Editorial 2: stone/warm background figure
  var _e2=document.getElementById('ed2');if(window.EBB_ASSETS?.ed2Img){_e2.style.backgroundImage='url('+window.EBB_ASSETS.ed2Img+')';_e2.style.backgroundSize='cover';_e2.style.backgroundPosition='60% center';}else{_e2.innerHTML=duoSVG(false);}

  // Category right: flat product shot
  // PageBot polish item 3: the word-list category panel (#catImg) was replaced by pb-home-cats; guard the old hook.
  var _ci=document.getElementById('catImg');if(!_ci){}else if(window.EBB_ASSETS?.catImgUrl){_ci.style.backgroundImage='url('+window.EBB_ASSETS.catImgUrl+')';_ci.style.backgroundSize='cover';_ci.style.backgroundPosition='center top';}else{_ci.innerHTML=flatSVG('#d8d4ce','#c4bfb8','#6b9ab8');}



  // Mega menu images
  var gcCard = document.getElementById('gcMegaCard');
  var prodHTML = P.slice(0,3).map(p=>`
    <div class="mimg" onclick="openProd(${p.id})">
      <div class="mimg-box">${figSVG(p, 200, 267)}</div>
      <div class="mimg-lbl">${p.name}</div>
    </div>`).join('');
  if(gcCard){ gcCard.insertAdjacentHTML('beforebegin', prodHTML); }
  else { var mi=document.getElementById('megaImgs'); if(mi) mi.innerHTML=prodHTML; }

  // Collections bg
  if(document.getElementById('collBg'))
    document.getElementById('collBg').innerHTML = '<img src="' + (window.__ebbAssets && window.__ebbAssets.shopBg || '') + '" style="width:100%;height:100%;object-fit:cover;object-position:center 20%;display:block;" alt="EBB Campaign"/>';
}

/*  SHOP  */
function renderShop() {
  document.getElementById('rnum').textContent = fil.length+' product'+(fil.length!==1?'s':'');
  document.getElementById('sg').innerHTML = fil.map(card).join('');
}
function applyF() {
  const cats=[];
  ['fc1','fc3','fc4','fc5','fc6'].forEach((id,i)=>{
    var el=document.getElementById(id);
    if(el&&el.checked) cats.push(['Shirts','Hoodies','Quarter Zips','Polos','Pants'][i]);
  });
  const purs=[];
  ['fp1','fp2','fp3'].forEach((id,i)=>{
    var el=document.getElementById(id);
    if(el&&el.checked) purs.push(['Performance','Recovery','Everyday'][i]);
  });
  fil=P.filter(p=>(cats.length===0||cats.includes(p.cat))&&(purs.length===0||purs.includes(p.pur))&&(cF.length===0||p.colors.some(c=>cF.includes(c)))&&p.price<=maxP);
  renderShop();
}
function togC(c,el){el.classList.toggle('on');cF.includes(c)?cF=cF.filter(x=>x!==c):cF.push(c);applyF()}
function pUpd(v){maxP=parseInt(v);document.getElementById('pval').textContent=v;applyF()}
function sortP(v){
  if(v==='asc')fil.sort((a,b)=>a.price-b.price);
  else if(v==='desc')fil.sort((a,b)=>b.price-a.price);
  else if(v==='newest')fil.sort((a,b)=>b.id-a.id);
  else fil=[...P].filter(p=>fil.some(f=>f.id===p.id));
  renderShop();
}
function resetF(){
  document.querySelectorAll('.sidebar input[type=checkbox]').forEach(c=>c.checked=false);
  document.querySelectorAll('.fsw').forEach(s=>s.classList.remove('on'));
  document.getElementById('psl').value=400; document.getElementById('pval').textContent='400';
  cF=[]; maxP=400; fil=[...P];
  if(document.getElementById('shopTitle')) document.getElementById('shopTitle').textContent='All Products';
  showPage('shop');
}
function filterGo(f){
  const tmap={All:'All Products',Performance:'Performance',Recovery:'Recovery',Everyday:'Everyday',new:'New Arrivals',best:'Best Sellers',sale:'Sale'};
  if(f==='All') fil=[...P];
  else if(f==='new') fil=P.filter(p=>p.badge==='new');
  else if(f==='best') fil=P.filter(p=>p.badge==='best');
  else if(f==='sale') fil=[];
  else if(['Performance','Recovery','Everyday'].includes(f)) fil=P.filter(p=>p.pur===f);
  else fil=P.filter(p=>p.cat===f);
  if(document.getElementById('shopTitle')) document.getElementById('shopTitle').textContent=tmap[f]||f;
  showPage('shop');
}
function hiC(el){document.querySelectorAll('.cat-item').forEach(i=>i.classList.remove('hi'));el.classList.add('hi')}
window.catHover=function(cat,el){
  hiC(el);
  var box=document.getElementById('catImg');if(!box)return;
  var urlMap={'Shirts':'/collections/all?cat=Shirts','Hoodies':'/collections/hoodies','Quarter Zips':'/collections/quarter-zips','Polos':'/collections/polos','Shorts':'/collections/shorts'};
  box.onclick=function(){window.location=urlMap[cat]||'/collections/all';};
  var p=P.find(function(x){return x.cat===cat;});
  box.style.transition='opacity .15s';box.style.opacity='0';
  setTimeout(function(){
    box.innerHTML=p?figSVG(p,600,800):flatSVG('#d8d4ce','#c4bfb8','#6b9ab8');
    box.style.opacity='1';
  },150);
};

/*  COLLECTIONS  */
function renderColl(){var cg=document.getElementById('collGrid');if(cg)cg.innerHTML=P.map(card).join('')}

/*  ABOUT  */
function renderAbout() {
  // Hero: full-width cinematic
  document.getElementById('aboutHeroBg').innerHTML = '<img src="' + (window.__ebbAssets && window.__ebbAssets.aboutBg || '') + '" style="width:100%;height:100%;object-fit:cover;object-position:center 20%;display:block;" alt="EBB Campaign"/>';
  // Mission image: editorial figure portrait
  document.getElementById('aboutMissionImg').innerHTML = duoSVG(false);
  // Team grid
  const team = [
    {name:'Alex Mercer',role:'Founder & CEO',bio:'Former D1 athlete and product designer. Built EBB to solve the problem he lived every day.',skin:'#c4956a',bg:'#e8e4de',suit:'#1a1a18'},
    {name:'Jordan Lee',role:'Head of Design',bio:'10 years designing for luxury menswear. Joined EBB to prove that performance and elegance belong together.',skin:'#d4a878',bg:'#d8d4ce',suit:'#6b9ab8'},
    {name:'Marcus Webb',role:'Head of Performance',bio:'Sports scientist and former professional rugby player. Every EBB piece passes his test before it ships.',skin:'#a07850',bg:'#1e2820',suit:'#f0ede8'}
  ];
  document.getElementById('teamGrid').innerHTML = team.map(m=>`
    <div class="team-card">
      <div class="team-card-img">${portraitSVG(m.skin, m.bg, m.suit)}</div>
      <div class="team-name">${m.name}</div>
      <div class="team-role">${m.role}</div>
      <div class="team-bio">${m.bio}</div>
    </div>`).join('');
}

/*  PRODUCT PAGE  */
function openProd(id) {
  const p = P.find(x=>x.id===id); if(!p) return;
  cur=p; selSz=null; selCI=0;
  document.getElementById('pdpBc').textContent = p.name;
  document.getElementById('pdpTag').textContent = p.badge==='new' ? 'Limited Edition' : '';
  document.getElementById('pdpCat').textContent = p.cat;
  document.getElementById('pdpName').textContent = p.name;
  document.getElementById('pdpPrice').textContent = '$'+p.price+'.00';
  // Gallery: main + alternate angle
  document.getElementById('pdpMain').innerHTML = prodImg(p, 700, 933, 0);
  document.getElementById('pdpThumb').innerHTML = prodImg(p, 700, 933, 1)+'<span class="pdp-lbl-tag">Model Info</span>';
  document.getElementById('pdpColName').textContent = p.colors[0];
  document.getElementById('pdpColOpts').innerHTML = p.colors.map((c,i)=>`
    <div class="pdp-copt ${i===0?'on':''}" style="background:${CM[c]};${c==='Chalk'?'border-color:#d0ccc8':''}" onclick="selCol(${i},'${c}',this)">
      <span class="ctip">${c}</span>
    </div>`).join('');
  const oos = (p.variants && p.variants.length) ? p.sizes.filter(s=>!p.variants.some(v=>v.avail&&v.o2===s)) : (p.soldOut||[]);
  document.getElementById('pdpSzs').innerHTML = p.sizes.map(s=>`
    <button class="pdp-sz ${oos.includes(s)?'oos':''}" onclick="selSzF('${s}',this)">${s}</button>`).join('');
  document.getElementById('pdpPair').innerHTML = P.filter(x=>x.id!==id).slice(0,2).map(r=>`
    <div class="pdp-pair-item" onclick="openProd(${r.id})">
      ${prodImg(r,340,453)}
      <div class="pdp-pair-name">${r.name}</div>
    </div>`).join('');
  document.getElementById('pdpAcc').innerHTML = [
    {t:'Product Details',b:p.det},
    {t:'Care Instructions',b:'Machine wash cold on gentle cycle. Lay flat to dry. Do not bleach or iron prints.'},
    {t:'Shipping & Returns',b:'Free standard shipping across Canada, delivered in 5–10 business days. U.S. orders ship free over $150 USD ($15 flat below). International shipping calculated at checkout. Free returns within 30 days. Items must be unworn and in original condition.'}
  ].map(a=>`<div class="acc-item"><button class="acc-btn" onclick="togAcc(this)">${a.t}<span class="acc-ico">+</span></button><div class="acc-body">${a.b}</div></div>`).join('');
  document.getElementById('pdpAtc').textContent='Add to cart';
  document.getElementById('pdpAtc').style.background='var(--ink)';
  var _pe=document.getElementById('pdpAtcErr');if(_pe){_pe.style.display='none';_pe.textContent='';}
  document.querySelectorAll('.acc-btn').forEach(b=>{b.classList.remove('open');b.nextElementSibling.classList.remove('open')});
  showPage('product');
}
function selCol(i,n,el){selCI=i;document.getElementById('pdpColName').textContent=n;document.querySelectorAll('.pdp-copt').forEach((c,j)=>c.classList.toggle('on',j===i))}
function selSzF(s,btn){if(btn.classList.contains('oos'))return;selSz=s;document.querySelectorAll('.pdp-sz').forEach(b=>b.classList.remove('on'));btn.classList.add('on')}
function togAcc(btn){btn.classList.toggle('open');btn.nextElementSibling.classList.toggle('open')}

/*  CART — real Shopify cart via /cart/add.js (drawer renders from /cart.js)  */
function addToCart(){
  const p=cur; if(!p) return;
  const btn=document.getElementById('pdpAtc');
  const err=document.getElementById('pdpAtcErr');
  if(err){err.style.display='none';err.textContent='';}
  const needSize = p.sizes && p.sizes.length>0;
  if(needSize && !selSz){toast('Please select a size');return}
  const col = (p.colors && p.colors.length) ? p.colors[selCI] : null;
  let v=null;
  if(p.variants && p.variants.length){
    v = p.variants.find(x=>x.avail && (!needSize || x.o2===selSz) && (!col || x.o1===col)) ||
        p.variants.find(x=>x.avail && (!needSize || x.o2===selSz));
  }
  if(!v){
    if(err){err.textContent='This combination is sold out — try another colour or size.';err.style.display='block';}
    return;
  }
  if(btn){btn.disabled=true;btn.textContent='Adding…';}
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({id:v.id,quantity:1})
  })
  .then(function(r){return r.json();})
  .then(function(d){
    if(d.id){
      if(btn){btn.textContent='Added';btn.style.background='var(--ebb)';}
      setTimeout(openCart,400);
      setTimeout(function(){if(btn){btn.disabled=false;btn.textContent='Add to cart';btn.style.background='var(--ink)';}},1800);
    } else {
      if(btn){btn.disabled=false;btn.textContent='Add to cart';}
      if(err){err.textContent=d.description||'Unable to add — please try again.';err.style.display='block';}
    }
  })
  .catch(function(){
    if(btn){btn.disabled=false;btn.textContent='Add to cart';}
    if(err){err.textContent='Something went wrong — please try again.';err.style.display='block';}
  });
}
function openCart(){
  const ov=document.getElementById('cartOv'),drw=document.getElementById('cartDrw');
  if(!ov||!drw)return;
  ebb_refreshCart(function(){
    ov.classList.add('open');drw.classList.add('open');
    var x=drw.querySelector('.cart-x');if(x)x.focus();
  });
}
function closeCart(){document.getElementById('cartOv').classList.remove('open');document.getElementById('cartDrw').classList.remove('open')}
/*  Escape closes the cart / wishlist drawers (dialog behavior)  */
document.addEventListener('keydown',function(e){
  if(e.key!=='Escape')return;
  var drw=document.getElementById('cartDrw');
  if(drw&&drw.classList.contains('open')){closeCart();return}
  var wl=document.getElementById('wlDrw');
  if(wl&&wl.classList.contains('open')&&typeof window.ebbCloseWishlist==='function'){window.ebbCloseWishlist();}
});
function ebb_refreshCart(cb){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(data){
    window.EBB_CART=data;
    var b=document.getElementById('cbadge');
    if(b){b.textContent=data.item_count;b.classList.toggle('on',data.item_count>0)}
    ebbRenderShopifyCart(data);
    if(cb)cb();
  }).catch(function(){if(cb)cb();});
}
var _cartBusy=false;
function ebb_changeQty(btn,delta){
  if(_cartBusy)return;
  var row=(btn&&btn.closest)?btn.closest('.ci'):null;
  if(!row)return;
  var key=row.getAttribute('data-key');
  var cur=parseInt(row.getAttribute('data-qty'),10)||0;
  if(row.getAttribute('data-gift')==='1'&&delta>0)return; // PageBot: the free gift can't be increased
  var newQty=Math.max(0,cur+delta);
  if(!key||newQty===cur)return;
  _cartBusy=true;
  row.querySelectorAll('.ci-qty-btn').forEach(function(b){b.disabled=true;});
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:newQty})})
    .then(function(r){return r.json();}).then(function(data){
      if(!data||typeof data.item_count==='undefined'){
        if(typeof toast==='function')toast((data&&data.description)?data.description:'That’s all we have in stock right now.');
        if(typeof ebb_refreshCart==='function')ebb_refreshCart(null);
        return;
      }
      window.EBB_CART=data;ebbRenderShopifyCart(data);var b=document.getElementById('cbadge');if(b){b.textContent=data.item_count;b.classList.toggle('on',data.item_count>0)}
    })
    .catch(function(){if(typeof toast==='function')toast('Could not update. Please try again.');if(window.EBB_CART)ebbRenderShopifyCart(window.EBB_CART);})
    .finally(function(){_cartBusy=false;});
}
function ebbMoney(cents){return '$'+((cents||0)/100).toFixed(2);}
function ebbRenderShopifyCart(data){
  var el=document.getElementById('cartBdy'),ft=document.getElementById('cartFt');
  if(!el)return;
  if(!data||!data.item_count){el.innerHTML='<div class="cart-empty"><p>Your bag is empty.</p><small>Start building your foundation.</small></div>';if(ft)ft.style.display='none';return}
  if(ft)ft.style.display='flex';
  var _cc=document.querySelector('.cart-currency');if(_cc)_cc.textContent=(data.currency==='CAD'?'CAD':'');
  var fill=document.getElementById('cartShipFill'),lbl=document.getElementById('cartShipLbl');
  if(fill&&lbl){
    // Free-shipping progress: CAD ships free always; USD free over $150 (AOV nudge).
    if(data.currency==='USD'){
      var _th=15000, _tot=data.total_price||0;
      if(_tot>=_th){ fill.style.width='100%'; lbl.innerHTML='<strong>You’ve unlocked free U.S. shipping</strong>'; }
      else { var _rem=((_th-_tot)/100).toFixed(2).replace(/\.00$/,''); fill.style.width=Math.max(5,Math.round(_tot/_th*100))+'%'; lbl.innerHTML='You’re <strong>$'+_rem+'</strong> away from free U.S. shipping'; }
    } else {
      fill.style.width='100%'; lbl.innerHTML='<strong>Free shipping across Canada</strong>';
    }
  }
  el.innerHTML=data.items.map(function(it,i){
    var line=i+1;
    // PageBot review fix: the URL already carries "?v=…", so "?width=120" was ignored and the full image loaded (the free
    // hat's 1080px PNG, 75 KB, on every page). Append with "&" when a query string exists.
    var img=it.featured_image&&it.featured_image.url?'<img src="'+it.featured_image.url+(it.featured_image.url.indexOf('?')>-1?'&':'?')+'width=160" alt="'+it.product_title+'" style="width:100%;height:100%;object-fit:cover">':'';
    var giftLine='';
    if(it.properties&&it.properties['Recipient Name']){
      var gname=it.properties['Recipient Name'],gemail=it.properties['Recipient Email']||'';
      var line1='Gift for '+gname+(gemail?' · '+gemail:'');
      var line2='';var gdate=it.properties['Send Date']||'';
      if(gdate){var sd=new Date(gdate+'T12:00:00'),mn=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];line2='Sending '+mn[sd.getMonth()]+' '+sd.getDate()+', '+sd.getFullYear();}
      var gmsg=it.properties['Gift Message']||'';
      function qe(s){return(s||'').replace(/&/g,'&amp;').replace(/"/g,'&quot;')}
      giftLine=
        '<div class="ci-gift" id="cig-'+line+'">'+
          line1+(line2?'<br>'+line2:'')+(gmsg?'<br><span class="ci-gift-msg">"'+gmsg+'"</span>':'')+
        '</div>'+
        '<button class="ci-gift-edit-btn" onclick="gcEditOpen('+line+')">'+
          '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>'+
          'Edit gift details'+
        '</button>'+
        '<div class="ci-gef" id="ci-gef-'+line+'" style="display:none"'+
          ' data-key="'+it.key+'"'+
          ' data-name="'+qe(gname)+'" data-email="'+qe(gemail)+'" data-msg="'+qe(gmsg)+'" data-date="'+qe(gdate)+'">'+
          '<input class="ci-gef-inp" id="ci-gef-n-'+line+'" placeholder="Recipient name">'+
          '<input class="ci-gef-inp" type="email" id="ci-gef-e-'+line+'" placeholder="Recipient email">'+
          '<textarea class="ci-gef-inp ci-gef-ta" id="ci-gef-m-'+line+'" placeholder="Message (optional)"></textarea>'+
          '<div class="ci-gef-sched-wrap">'+
            '<button class="ci-gef-sched-btn on" onclick="gcCartSched('+line+',this,\'now\')">Send Now</button>'+
            '<button class="ci-gef-sched-btn" onclick="gcCartSched('+line+',this,\'date\')">Schedule</button>'+
          '</div>'+
          '<input type="hidden" id="ci-gef-d-'+line+'">'+
          '<div class="gcm-cal" id="ci-cart-cal-'+line+'" style="display:none;margin-top:10px"></div>'+
          '<div id="ci-cart-chip-'+line+'" class="gcm-date-chip" style="display:none;margin-top:10px">'+
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>'+
            '<span class="gcm-date-chip-lbl" id="ci-cart-chip-lbl-'+line+'"></span>'+
            '<button class="gcm-date-chip-change" onclick="gcCartCalChange('+line+')">Change</button>'+
          '</div>'+
          '<div class="ci-gef-row">'+
            '<button class="ci-gef-cancel" onclick="gcEditClose('+line+')">Cancel</button>'+
            '<button class="ci-gef-save" onclick="gcEditSave('+line+')">Save</button>'+
          '</div>'+
        '</div>';
    }
    var isFreeHat = (it.handle === 'launch-hat-free-gift');
    // PageBot: "Remove" takes the free gift out in one step (was -1, so 8 hats became 7)
    var qtyHtml = isFreeHat
      ? '<button class="ci-rm" onclick="ebb_changeQty(this,-'+it.quantity+')" aria-label="Remove free gift">Remove</button>'
      : '<div class="ci-qty"><button class="ci-qty-btn" onclick="ebb_changeQty(this,-1)">−</button><span class="ci-qty-num">'+it.quantity+'</span><button class="ci-qty-btn" onclick="ebb_changeQty(this,1)">+</button></div>';
    return '<div class="ci" data-key="'+it.key+'" data-qty="'+it.quantity+'"'+(isFreeHat?' data-gift="1"':'')+'><div class="ci-img">'+img+'</div><div class="ci-info"><div class="ci-name">'+it.product_title+'</div>'+giftLine+'<div class="ci-meta">'+(it.variant_title||'')+'</div><div class="ci-price">'+ebbMoney(it.price)+'</div>'+qtyHtml+'</div></div>';
  }).join('');
  var tot=document.getElementById('cartTotal');
  if(tot)tot.textContent=ebbMoney(data.total_price);
}
function gcEditOpen(line){
  var f=document.getElementById('ci-gef-'+line);if(!f)return;
  document.getElementById('ci-gef-n-'+line).value=f.dataset.name||'';
  document.getElementById('ci-gef-e-'+line).value=f.dataset.email||'';
  document.getElementById('ci-gef-m-'+line).value=f.dataset.msg||'';
  var existDate=f.dataset.date||'';
  document.getElementById('ci-gef-d-'+line).value=existDate;
  var calDiv=document.getElementById('ci-cart-cal-'+line);
  var chip=document.getElementById('ci-cart-chip-'+line);
  if(calDiv)calDiv.style.display='none';
  if(chip)chip.style.display='none';
  var schBtns=f.querySelectorAll('.ci-gef-sched-btn');
  schBtns.forEach(function(b){b.classList.remove('on');});
  if(existDate){
    if(schBtns[1])schBtns[1].classList.add('on');
    var dt=new Date(existDate+'T12:00:00');
    var mn=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var lbl=document.getElementById('ci-cart-chip-lbl-'+line);
    if(lbl)lbl.innerHTML='Sending<br>'+mn[dt.getMonth()]+' '+dt.getDate()+', '+dt.getFullYear();
    if(chip)chip.style.display='flex';
  }else{if(schBtns[0])schBtns[0].classList.add('on');}
  document.getElementById('cig-'+line).style.display='none';
  f.style.display='block';
}
window.gcCartCal={
  _s:{},
  MN:['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
  DY:['Su','Mo','Tu','We','Th','Fr','Sa'],
  init:function(line){var n=new Date();this._s[line]=this._s[line]||{year:n.getFullYear(),month:n.getMonth(),selected:null};this._render(line);},
  _render:function(line){
    var el=document.getElementById('ci-cart-cal-'+line);if(!el)return;
    if(!this._s[line]){var n=new Date();this._s[line]={year:n.getFullYear(),month:n.getMonth(),selected:null};}
    var s=this._s[line];
    var today=new Date();today.setHours(0,0,0,0);
    var first=new Date(s.year,s.month,1).getDay(),total=new Date(s.year,s.month+1,0).getDate();
    var self=this;
    var h='<div class="gcm-cal-hd"><button class="gcm-cal-nav" onclick="gcCartCal._nav('+line+',-1)">&#8249;</button><span class="gcm-cal-mon">'+self.MN[s.month]+' '+s.year+'</span><button class="gcm-cal-nav" onclick="gcCartCal._nav('+line+',1)">&#8250;</button></div><div class="gcm-cal-grid">';
    self.DY.forEach(function(d){h+='<div class="gcm-cal-dow">'+d+'</div>';});
    for(var i=0;i<first;i++)h+='<div class="gcm-cal-day empty"></div>';
    for(var d=1;d<=total;d++){var dt=new Date(s.year,s.month,d);dt.setHours(0,0,0,0);var cls='gcm-cal-day';if(dt<today)cls+=' past';else if(dt.getTime()===today.getTime())cls+=' today';if(s.selected&&dt.getTime()===s.selected.getTime())cls+=' on';h+='<div class="'+cls+'" onclick="gcCartCal._pick('+line+','+s.year+','+s.month+','+d+')">'+d+'</div>';}
    h+='</div>';el.innerHTML=h;
  },
  _nav:function(line,dir){var s=this._s[line];if(!s)return;s.month+=dir;if(s.month<0){s.month=11;s.year--;}if(s.month>11){s.month=0;s.year++;}this._render(line);},
  _pick:function(line,y,m,d){
    var s=this._s[line];if(!s)return;s.selected=new Date(y,m,d);
    var ds=y+'-'+String(m+1).padStart(2,'0')+'-'+String(d).padStart(2,'0');
    var inp=document.getElementById('ci-gef-d-'+line);if(inp)inp.value=ds;
    var calDiv=document.getElementById('ci-cart-cal-'+line);if(calDiv)calDiv.style.display='none';
    var lbl=document.getElementById('ci-cart-chip-lbl-'+line);if(lbl)lbl.innerHTML='Sending<br>'+this.MN[m]+' '+d+', '+y;
    var chip=document.getElementById('ci-cart-chip-'+line);if(chip)chip.style.display='flex';
    this._render(line);
  }
};
window.gcCartSched=function(line,btn,mode){
  var f=document.getElementById('ci-gef-'+line);if(!f)return;
  f.querySelectorAll('.ci-gef-sched-btn').forEach(function(b){b.classList.remove('on');});btn.classList.add('on');
  var calDiv=document.getElementById('ci-cart-cal-'+line),chip=document.getElementById('ci-cart-chip-'+line),inp=document.getElementById('ci-gef-d-'+line);
  if(mode==='now'){if(calDiv)calDiv.style.display='none';}
  else{if(chip)chip.style.display='none';if(calDiv){calDiv.style.display='block';gcCartCal.init(line);}}
};
window.gcCartCalChange=function(line){
  var chip=document.getElementById('ci-cart-chip-'+line);if(chip)chip.style.display='none';
  var calDiv=document.getElementById('ci-cart-cal-'+line);if(calDiv)calDiv.style.display='block';
  var inp=document.getElementById('ci-gef-d-'+line);
  if(inp&&inp.value&&!gcCartCal._s[line]){var dt=new Date(inp.value+'T12:00:00');gcCartCal._s[line]={year:dt.getFullYear(),month:dt.getMonth(),selected:dt};}
  gcCartCal._render(line);
};
function gcEditClose(line){
  document.getElementById('cig-'+line).style.display='block';
  document.getElementById('ci-gef-'+line).style.display='none';
}
function gcEditSave(line){
  var name=(document.getElementById('ci-gef-n-'+line).value||'').trim();
  var email=(document.getElementById('ci-gef-e-'+line).value||'').trim();
  var msg=(document.getElementById('ci-gef-m-'+line).value||'').trim();
  var f=document.getElementById('ci-gef-'+line);
  var _row=f?f.closest('.ci'):null;
  var _key=_row?_row.getAttribute('data-key'):null;
  var _qty=_row?(parseInt(_row.getAttribute('data-qty'),10)||1):1;
  var schBtns=f?f.querySelectorAll('.ci-gef-sched-btn'):[];
  var isScheduled=schBtns.length>1&&schBtns[1].classList.contains('on');
  var date=isScheduled?(document.getElementById('ci-gef-d-'+line).value||''):'';
  if(!name||!email){toast('Please enter recipient name and email.');return;}
  var props={'Send as Gift':'Yes','Recipient Name':name,'Recipient Email':email};
  if(msg)props['Gift Message']=msg;
  if(date)props['Send Date']=date;
  if(!_key){toast('Could not update. Please try again.');return;}
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:_key,quantity:_qty,properties:props})})
    .then(function(r){return r.json();})
    .then(function(d){window.EBB_CART=d;ebbRenderShopifyCart(d);var b=document.getElementById('cbadge');if(b){b.textContent=d.item_count;b.classList.toggle('on',d.item_count>0)}})
    .catch(function(){toast('Could not update. Please try again.');});
}
/*  TOAST — global so inline onclick handlers can reach it  */
window.toast=function(m){var t=document.getElementById('toast');if(!t)return;t.textContent=m;t.classList.add('show');setTimeout(function(){t.classList.remove('show')},2400)};

/*  ANNOUNCEMENT — global so onclick="annNext()" works  */
var _ANNS=[
  'Free shipping in Canada<span class="ann-sec"> &nbsp;|&nbsp; Free shipping in the U.S. on orders $150+</span> &nbsp;&nbsp;<a href="/collections/all">Shop now</a>'
];
var _ai=0;
function _showAnn(){var el=document.getElementById('annText');if(el&&!el.getAttribute('data-server'))el.innerHTML=_ANNS[_ai];}
window.annNext=function(){_ai=(_ai+1)%_ANNS.length;_showAnn()};
window.annPrev=function(){_ai=(_ai-1+_ANNS.length)%_ANNS.length;_showAnn()};

document.addEventListener('DOMContentLoaded', function() {
/*  ANNOUNCEMENT INIT  */
_showAnn(); setInterval(window.annNext,5000);

/*  MEGA MENU  */
var sh=document.getElementById('shopHov'), mw=document.getElementById('megaWrap');
if(sh&&mw){
  var mT;
  sh.addEventListener('mouseenter',function(){clearTimeout(mT);mw.classList.add('open')});
  sh.addEventListener('mouseleave',function(){mT=setTimeout(function(){mw.classList.remove('open')},220)});
  mw.addEventListener('mouseenter',function(){clearTimeout(mT)});
  mw.addEventListener('mouseleave',function(){mT=setTimeout(function(){mw.classList.remove('open')},220)});
}

/*  NAV SCROLL  */
var navEl=document.getElementById('nav');
if(navEl)window.addEventListener('scroll',function(){navEl.classList.toggle('raised',window.scrollY>20)});

/*  REVEAL  */
if('IntersectionObserver' in window){
  var ro=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');ro.unobserve(e.target)}})},{threshold:.06});
  document.querySelectorAll('.rev').forEach(function(el){ro.observe(el)});
}

/*  CART BADGE INIT (load live count on page load for non-home pages)  */
if(!document.getElementById('page-home')){
  ebb_refreshCart(null);
}

/*  INIT HOME SPA  */
if(document.getElementById("page-home"))renderHome();
});
